module.exports = __webpack_public_path__ + "img/print.2150ea09.svg";